/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from 'react'
import { Row, Col, Input, Select, message, Drawer, TimePicker, Form } from 'antd'
import Checkbox from '../../../../components/Custom/CustomCheckbox'
import { Link } from 'react-router-dom'
import _ from 'lodash'
import moment from 'moment'
import { observer, inject } from 'mobx-react'
import { compose } from 'recompose'
import { graphql } from 'react-apollo'
import gql from 'graphql-tag'

class Index extends Component {
	constructor(props) {
		super(props)

		this.state = {
			isSaving: false
		}
        
		this.handleSubmit = this.handleSubmit.bind(this)
	}
    
	handleSubmit(e) {
		e.preventDefault()
		const { form, AuthStore, saveBarangayShiftSchedule, onClose, isEdit, selectedBarangayShiftSchedule } = this.props
		const { barangay_uid } = AuthStore
		const { resetFields } = form
		
		form.validateFields((err, values) => {
			if (err) {
				return false
			}

			const shift_start = moment(values.shift_start).format('HH:mm')
			const shift_end = moment(values.shift_end).format('HH:mm')
			let params = Object.assign({}, values, {
				barangay_uid,
				shift_start,
				shift_end
			})
			if (isEdit && selectedBarangayShiftSchedule) {
				params = Object.assign({}, params, { barangay_shift_schedule_uid: selectedBarangayShiftSchedule.uid })
			}
			console.log('params', params)

			message.loading({ key: 'set_message', content: 'Saving shift schedule, please wait..' })
			this.setState({ isSaving: true }, () => {
				saveBarangayShiftSchedule(params).then((response) => {
					this.setState({ isSaving: false })
					message.success({ key: 'set_message', content: 'Shift schedule successfully saved.' })
					onClose()
				}).catch(err => {
					this.setState({ isSaving: false })
					console.log('error saving barangay shift schedule')
					message.error({ key: 'set_message', content: err.message.replace('GraphQL error:', '') })
					resetFields()
				})
			})
		})
	}

	render() {
		const { visible, onClose, form, selectedBarangayShiftSchedule } = this.props
		const { getFieldDecorator } = form
        
		return (
			<Drawer
				title="Manage Shift Schedule"
				placement="right"
				// closable={false}
				onClose={onClose}
				visible={visible}
				width={'35%'}
				bodyStyle={{ maxHeight: '90%', overflow: 'scroll' }}
			>
				<Form onSubmit={this.handleSubmit}>
					<Row>
						<Form.Item label='Shift Name'>
							{ getFieldDecorator('shift_name', {
								initialValue: (selectedBarangayShiftSchedule) ? selectedBarangayShiftSchedule.shift_name : null,
								rules: [{
									required: true,
									message: 'This field is required.'
								}]
							})
							(
								<Select placeholder='Select Shift Name'>
									<Select.Option value='Day Shift'>Day Shift</Select.Option>
									<Select.Option value='Night Shift'>Night Shift</Select.Option>
								</Select>
							)}
						</Form.Item>
					</Row>
					<Row gutter={16}>
						<Col md={12} sm={24}>
							<Form.Item label='Shift Start Time'>
								{ getFieldDecorator('shift_start', {
									initialValue: (selectedBarangayShiftSchedule) ? 
										moment(selectedBarangayShiftSchedule.shift_start, 'HH:mm') : moment(moment('08:00 am', 'hh:mm a')),
									rules: [{
										required: true,
										message: 'This field is required.'
									}]
								})
								(
									<TimePicker 
										use12Hours
										format='hh:mm a'
										style={{ width: '100%' }}
									/>
								)}
							</Form.Item>
						</Col>
						<Col md={12} sm={24}>
							<Form.Item label='Shift End Time'>
								{ getFieldDecorator('shift_end', {
									initialValue: (selectedBarangayShiftSchedule) ? 
										moment(selectedBarangayShiftSchedule.shift_end, 'HH:mm') : moment(moment('05:00 pm', 'hh:mm a')),
									rules: [{
										required: true,
										message: 'This field is required.'
									}]
								})
								(
									<TimePicker
										use12Hours
										format='hh:mm a'
										style={{ width: '100%' }}
									/>
								)}
							</Form.Item>
						</Col>
					</Row>
				</Form>
				<div
					style={{
						position: 'absolute',
						right: 0,
						bottom: 10,
						width: '100%',
						borderTop: '1px solid #e9e9e9',
						padding: '10px 16px',
						background: '#fff',
						textAlign: 'center',
					}}
				>
					<button type="button" className="btn btn-block btn-primary btn-rounded waves-effect waves-light" onClick={this.handleSubmit}>Save</button>
				</div>
			</Drawer>
		)
	}
}

const SET_BARANGAY_SHIFT_SCHEDULE = gql`
    mutation setBarangayShiftSchedule($input: JSON) {
		setBarangayShiftSchedule(input: $input)
    }
`

const composed = compose(
	Form.create({ name: 'form-barangay-shift-schedule' }),
	inject('AuthStore'),
	graphql(SET_BARANGAY_SHIFT_SCHEDULE, {
		props({ mutate }) {
			return {
				saveBarangayShiftSchedule(params) {
					return mutate({
						variables: { input: params },
					  	refetchQueries: ['barangayShiftSchedules']
					})
				}
			}
		}
	}),
	observer
)

export default composed(Index)
